// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// Register a global custom directive called `v-focus`, based on the Vue docs
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    Vue.nextTick(() => el.focus())
  }
})

// don't start the application if the browser is IE
var ua = window.navigator.userAgent
if (ua.indexOf('Trident/7.0') === -1) {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
  })
}



// WEBPACK FOOTER //
// ./src/main.js